<script setup>

  import { useSystem } from "../../store/system"
  import {onActivated, onMounted, watch} from "vue";
  import {useProducts} from "../../store/products";
  import {useRouter} from "vue-router";

  const router = useRouter()
  const systemStore = useSystem()
  //获取系统信息
  systemStore.systemInfoApi()
  //获取轮播图
  systemStore.bannerApi()
  systemStore.virtualWithdrawListApi()

  const color = systemStore.getBlockIconColor()

  const productStore = useProducts()
  //获取产品列表
  productStore.productsListApi()

  watch(() => systemStore.website, (value, oldValue) => {
    window.document.title = systemStore.website.website_name
  },{ deep: true })


  onMounted(() => {
    // 动态雾霾效果
    if (document.querySelector('.section__canvas--second')) {
      VANTA.FOG({
        el: "#canvas2",
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 200.00,
        minWidth: 200.00,
        highlightColor: 0xA034FA,
        midtoneColor: 0xA034FA,
        lowlightColor: 0xE66C12,
        baseColor: 0x16142A,
        blurFactor: 0.90,
        speed: 5.70,
        zoom: 1.00
      })
    }

    var Scrollbar = window.Scrollbar;
    if (document.querySelector('.deals__table-wrap')) {
      Scrollbar.init(document.querySelector('.deals__table-wrap'), {
        damping: 0.1,
        renderByPixels: true,
        alwaysShowTracks: true,
        continuousScrolling: true,
      });
    }

    setTimeout(() => {
      // 动态雾霾效果
      if (document.querySelector('.section__canvas--second')) {
        VANTA.FOG({
          el: "#canvas3",
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          minHeight: 200.00,
          minWidth: 200.00,
          highlightColor: 0xA034FA,
          midtoneColor: 0xA034FA,
          lowlightColor: 0xE66C12,
          baseColor: 0x16142A,
          blurFactor: 0.90,
          speed: 5.70,
          zoom: 1.00
        })
      }
      if (document.querySelector('.section__canvas--second4')) {
        VANTA.FOG({
          el: "#canvas4",
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          minHeight: 200.00,
          minWidth: 200.00,
          highlightColor: 0xA034FA,
          midtoneColor: 0xA034FA,
          lowlightColor: 0xE66C12,
          baseColor: 0x16142A,
          blurFactor: 0.90,
          speed: 5.70,
          zoom: 1.00
        })
      }
    }, 500)

    setTimeout(() => {
      if (document.querySelector('.roadmap__carousel')) {
        var elms = document.getElementsByClassName('roadmap__carousel');

        for ( var i = 0; i < elms.length; i++ ) {
          new Splide(elms[ i ], {
            type: 'loop',
            perPage: 3,
            drag: true,
            pagination: false,
            autoWidth: false,
            auto: true,
            speed: 800,
            gap: 10,
            arrows: false,
            focus: 0,
            breakpoints: {
              767: {
                pagination: true,
                arrows: false,
                perPage: 1,
              },
              991: {
                pagination: true,
                arrows: false,
                perPage: 2,
              },
              1199: {
                pagination: true,
                arrows: false,
                perPage: 3,
              },
            }
          }).mount();
        }
      }
    }, 1500)

  })

  onActivated(() => {
    document.title = 'Top Cloud Mining Platform | AI-Powered Bitcoin Mining | HexMiner';
    document.querySelector('meta[name="description"]').setAttribute('content', 'Start Bitcoin cloud mining with HexMiner! Best cloud mining platform for beginners. Earn Bitcoin daily with high ROI & zero-cost trials.');
  })

  const tempColors = []
  const colorEqule = () => {
    if (tempColors.length % 2 === 0) {
      let color = systemStore.getRandomColor()
      tempColors.push("stats__dodger--" + color)
    }else{
      tempColors.push(tempColors[tempColors.length-1])
    }
    return tempColors[tempColors.length-1]
  }
</script>

<template>
    <el-image src="img/bg.png" fit="cover" class="!tw-absolute tw-w-full tw-top-0" :class="systemStore.getIsMobile? 'tw-h-[100vh]': ''"></el-image>
    <!--  one line -->
    <section class="hero">
      <el-row class="container xs:pb-[4rem] xs:pt-[3rem] sm:py-[6rem]">
        <el-col :span="24">

          <el-row>
            <el-col :span="24" :md="12">
              <div class="hero__content hero__content--first xs:!tw-pr-0 md:!tw-pr-[1rem] ">
                <div class="hero__title xs:!tw-text-[1.6rem] md:!tw-text-[2rem]"><strong class="">{{systemStore.getFrontModuleContent(15).title}}</strong> <br><span>{{systemStore.getFrontModuleContent(15).sub_title}}</span></div>
                <div class="hero__btns">
                  <a href="/Products" class="hero__btn xs:!tw-w-[49%] md:!tw-w-[220px] xs:!tw-text-[13px] md:!tw-text-[16px]">Start cloud mining</a>
                  <a href="/Contest" class="hero__btn xs:!tw-w-[49%] md:!tw-w-[220px] xs:!tw-text-[13px] md:!tw-text-[16px] hero__btn--light">Earn Free Bitcoin</a>
                </div>
              </div>
            </el-col>
<!--            <el-col :span="24" :md="12">-->
<!--              <video controls class="tw-w-full tw-h-full xs:!tw-mt-[3rem] md:!tw-mt-0">-->
<!--                <source src="HExMiner.mp4" type="video/mp4">-->
<!--              </video>-->
<!--&lt;!&ndash;              <iframe&ndash;&gt;-->
<!--&lt;!&ndash;                  class="tw-rounded-md tw-w-full tw-h-full xs:!tw-mt-[3rem] lg:!tw-mt-0"&ndash;&gt;-->
<!--&lt;!&ndash;                  width="100%"&ndash;&gt;-->
<!--&lt;!&ndash;                  height="100%"&ndash;&gt;-->
<!--&lt;!&ndash;                  src="https://www.youtube.com/embed/_mpeafRUD0U"&ndash;&gt;-->
<!--&lt;!&ndash;                  frameborder="0"&ndash;&gt;-->
<!--&lt;!&ndash;                  allowfullscreen>&ndash;&gt;-->
<!--&lt;!&ndash;              </iframe>&ndash;&gt;-->
<!--            </el-col>-->
          </el-row>

        </el-col>
        <el-col :span="24">
          <!-- statistics -->
          <div class="section tw-mt-[4rem]">
<!--            <div class="container">-->
              <div class="row">
                <div class="col-12 col-sm-6 col-xl-3" v-for="(item, index) in systemStore.getFrontModuleContent(17, 1)?.json_data" :key="index">
                  <!-- stats -->
                  <div class="stats">
                    <span class="stats__value tw-text-[20px]">{{item.title}}</span>
                    <p class="stats__name">{{item.desc}}</p>

                    <!-- design elements -->
                    <span class="stats__dodger stats__dodger--left" :class="colorEqule()"></span>
                    <span class="stats__dodger stats__dodger--right" :class="tempColors[tempColors.length-1]"></span>
                  </div>
                  <!-- end stats -->
                </div>
              </div>
<!--            </div>-->
          </div>
          <!-- end statistics -->
        </el-col>
      </el-row>
    </section>

<!--    &lt;!&ndash; banner &ndash;&gt;-->
<!--    <el-row>-->
<!--      <el-col :span="24">-->
<!--        <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel" data-bs-interval="8000">-->
<!--          <div class="h-14 bg-gradient-to-b from-[#16142a] via-[#16142a] to-transparent absolute top-[-1.8rem] z-[99999] w-full blur-[1px]"></div>-->
<!--          <div class="carousel-indicators">-->
<!--            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>-->
<!--            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>-->
<!--            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>-->
<!--          </div>-->
<!--          <div class="carousel-inner" v-if="systemStore.getBannerList.length > 0">-->
<!--            <div class="carousel-item" :class="{ active: index === 0 }" v-for="(item, index) in systemStore.getBannerList" :key="index">-->
<!--              <img :src="item.image" class="d-block w-100 h-[650px] object-cover">-->
<!--              <div class="carousel-caption d-none d-md-block">-->
<!--                <div class="text-[30px] mb-[20px]">{{item.title}}</div>-->
<!--                <p class="pb-[20px]">{{item.desc}}</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">-->
<!--            <span class="carousel-control-prev-icon" aria-hidden="true"></span>-->
<!--            <span class="visually-hidden">Previous</span>-->
<!--          </button>-->
<!--          <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">-->
<!--            <span class="carousel-control-next-icon" aria-hidden="true"></span>-->
<!--            <span class="visually-hidden">Next</span>-->
<!--          </button>-->
<!--          <div class="h-14 bg-gradient-to-t from-[#16142a] via-[#16142a] to-transparent absolute bottom-[-1.8rem] z-[99999] w-full blur-[1px]"></div>-->
<!--        </div>-->
<!--      </el-col>-->
<!--    </el-row>-->
<!--    &lt;!&ndash; end banner &ndash;&gt;-->


    <!-- How it works -->
    <div class="section section--head tw-pt-0 tw-mt-0">
      <div class="container">
        <div class="row">
          <!-- title  对应的模块id => 1(不可更改) -->
          <div class="col-12 col-md-10 offset-md-1 col-lg-6 offset-lg-3">
            <div class="section__title">
              <h1>{{systemStore.getFrontModuleContent(1)?.title}}</h1>
              <p>{{systemStore.getFrontModuleContent(1)?.sub_title}}</p>
            </div>
          </div>
          <!-- end title -->
        </div>

        <div class="row">
          <div class="col-12" v-for="(item, index) in systemStore.getFrontModuleContent(1)?.json_data" :key="index">
            <!-- step -->
            <div class="step">
              <h3 class="step__title">{{item.title}}</h3>
              <p class="step__text">{{item.desc}}</p>

              <!-- design elements -->
              <span class="block-icon" :class="color">
<!--							<i class="ti ti-number-1"></i>-->
                <div class="text-white text-[22px]">{{++index}}</div>
              </span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
            <!-- end step -->
          </div>
        </div>
      </div>
    </div>
    <!-- end head -->

    <!-- Our Features -->
    <div class="container">
      <!-- head -->
      <div class="section section--head mt-0">
        <div class="container">
          <div class="row">
            <!-- title -->
            <div class="col-12 col-md-10 offset-md-1 col-lg-6 offset-lg-3">
              <div class="section__title">
                <h1>{{systemStore.getFrontModuleContent(2)?.title}}</h1>
                <p>{{systemStore.getFrontModuleContent(2)?.sub_title}}</p>
              </div>
            </div>
            <!-- end title -->
          </div>
        </div>
      </div>
      <!-- end head -->
      <el-row :gutter="systemStore.getIsMobile? 0: 30" class="section mt-0">
        <el-col :span="24" :md="8" v-for="(item, index) in systemStore.getFrontModuleContent(2)?.json_data" :key="index">
          <div class="stats text-white tw-h-full">

            <div class="tw-p-[3rem] text-center">
              <el-image :src="item.image" fit="cover" class="tw-w-[50px] tw-h-[50px]"></el-image>
              <div class="tw-font-bold tw-text-[18px] tw-py-2">{{item.title}}</div>
              <div class="tw-text-[16px] tw-text-left">{{item.desc}}</div>
              <!--              <div class="tw-mt-3 tw-flex tw-justify-end tw-items-center tw-font-bold tw-cursor-pointer tw-hover:text-purple-600">-->
              <!--                Read more-->
              <!--                <el-icon size="20"><CaretRight /></el-icon>-->
              <!--              </div>-->
            </div>

            <!-- design elements -->
            <span class="stats__dodger stats__dodger--left stats__dodger--purple"></span>
            <span class="stats__dodger stats__dodger--right stats__dodger--purple"></span>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- end Our Features -->


    <!-- Choose Your Beast ICOMiner Plan -->
    <section class="section">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-8 offset-xl-2">
            <div class="section__title">
              <h2>{{systemStore.getFrontModuleContent(3)?.title}}</h2>
              <p>{{systemStore.getFrontModuleContent(3)?.sub_title}}</p>
            </div>
          </div>
          <!-- end title -->
        </div>

        <el-row :gutter="systemStore.getIsMobile? 0: 30">
          <el-col :span="24" :md="8" v-for="(item, index) in productStore.getProductsList" :key="index">
            <div class="feature h-auto py-5 text-white" style="font-family: 'Manrope', sans-serif;">
              <el-image class="tw-w-[4.5rem] tw-h-[4.5rem] tw-mb-3 tw-rounded-full" fit="cover" :src="item.image? item.image: 'img/logo.svg'"></el-image>
              <h3 class="feature__title">{{item.name}}</h3>
              <p class="tw-font-bold tw-text-[1.3rem]">$ {{parseFloat(item.amount)}}</p>

              <!--              固定-->
              <div v-if="item.profit_type == 1" class="tw-text-[14px] tw-mt-4 tw-flex tw-justify-between tw-items-center feature__text tw-w-full">
                <div>Daily Rewards</div>
                <div>$ {{parseFloat(item.fixed_profit)}}</div>
              </div>
              <!--              百分比-->
              <div v-if="item.profit_type == 2" class="tw-text-[14px] tw-mt-4 tw-flex tw-justify-between tw-items-center feature__text tw-w-full">
                <div>Daily Rewards</div>
                <div>$ {{parseFloat(item.amount) * parseFloat(item.percent_profit)}}</div>
              </div>

              <div class="tw-text-[14px] tw-mt-4 tw-flex tw-justify-between tw-items-center feature__text tw-w-full">
                <div>Total Earnings</div>
                <div>$ {{parseFloat(item.expected_profit)}}</div>
              </div>

              <div class="tw-text-[14px] tw-mt-4 tw-flex tw-justify-between tw-items-center feature__text tw-w-full">
                <div>Matured Amount</div>
                <div>$ {{parseFloat(item.amount)}} + $ {{parseFloat(item.expected_profit)}}</div>
              </div>

              <div class="tw-text-[14px] tw-mt-2 tw-flex tw-justify-between tw-items-center feature__text tw-w-full">
                <div>Contract Duration</div>
                <div>{{item.products_day}} Day</div>
              </div>

              <div class="tw-text-[14px] tw-mt-4 tw-flex tw-justify-between tw-items-center feature__text tw-w-full">
                <div>Principal Refund </div>
                <div v-if="item.return_capital == 1">Yes</div>
                <div v-else>No</div>
              </div>


              <button class="section__btn tw-mt-10" type="button" @click="router.push({path:'/ProductDetail', query:{id: item.products_id}})">Invest Now</button>
              <!--              <div class="section__btns section__btns&#45;&#45;two">-->
              <!--                <a href="faq.html" class="section__btn">Alle ansehen</a>-->
              <!--                <button class="section__btn section__btn&#45;&#45;light" data-bs-toggle="modal" data-bs-target="#modal-ask" type="button">Eine Frage stellen</button>-->
              <!--              </div>-->

              <!-- design elements -->
              <span class="block-icon" :class="systemStore.getBlockIconColor()">
							  <i class="ti ti-mood-dollar"></i>
						  </span>
              <span class="screw screw--bl"></span>
              <span class="screw screw--tr"></span>
              <span class="screw screw--big-br"></span>
            </div>
          </el-col>
          <el-col :span="24">
            <button class="tw-justify-self-center mt-5 section__btn section__btn--light" type="button" @click="router.push('/Products')">Load More <i class="ti ti-arrow-move-right ml-2 text-[28px]"></i></button>
          </el-col>
        </el-row>
      </div>
    </section>
    <!-- end Choose Your Beast ICOMiner Plan -->

    <!-- Why Choose ICOMiner -->
    <section class="section">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <div class="section__title">
              <h2>{{systemStore.getFrontModuleContent(5)?.title}}</h2>
              <p>{{systemStore.getFrontModuleContent(5)?.sub_title}}</p>
            </div>
          </div>
          <!-- end title -->
        </div>

        <el-row :gutter="systemStore.getIsMobile? 0: 30">
          <el-col class="mt-5" :span="24" :md="8" v-for="(item, index) in systemStore.getFrontModuleContent(5)?.json_data" :key="index">
            <div class="feature py-5 tw-h-full tw-justify-start">
              <h3 class="feature__title">{{item.title}}</h3>
              <p class="feature__text">{{item.desc}}</p>

              <!-- design elements -->
              <span class="block-icon" :class="systemStore.getBlockIconColor()">
							  <el-image class="tw-w-[25px]" :src="item.image" fit="cover"></el-image>
						  </span>
              <span class="screw screw--bl"></span>
              <span class="screw screw--tr"></span>
              <span class="screw screw--big-br"></span>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>
    <!-- end features -->

    <!-- recent deals -->
    <section class="section">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
            <div class="section__title">
              <h2>{{systemStore.getFrontModuleContent(7).title}}</h2>
              <p>{{systemStore.getFrontModuleContent(7)?.sub_title}}</p>
            </div>
          </div>
          <!-- end title -->

          <!-- deals table -->
          <div class="col-12">
            <div class="deals">
              <div class="deals__table-wrap tw-h-[50vh]">
                <table class="deals__table min-w-0">
                  <thead>
                  <tr>
                    <th class="tw-w-1/5">username</th>
                    <th class="tw-w-1/5">Coin Name</th>
                    <th class="tw-w-1/5">Amount</th>
<!--                    <th class="tw-w-1/5">Withdraw Time</th>-->
                    <th class="tw-w-[10%]">Status</th>
                  </tr>
                  </thead>
                </table>
<!--                <Vue3Marquee class="tw-w-full" style="height: calc(50vh - 53px);" :pauseOnHover="true" :vertical="true" :duration="5" :clone="true">-->
<!--                  <table class="deals__table min-w-0">-->
<!--                    <tbody>-->
<!--                    <tr v-for="(item, index) in systemStore.getVirtualWithdrawList" :key="index">-->
<!--                      <td class="tw-w-1/5">-->
<!--                        <div class="deals__text">{{item.username}}</div>-->
<!--                      </td>-->
<!--                      <td class="tw-w-1/5">-->
<!--                        <div class="deals__text deals__exchange"><img v-if="item.image" :src="item.image" alt="">{{item.coin_name}}</div>-->
<!--                      </td>-->
<!--                      <td class="tw-w-1/5">-->
<!--                        <div class="deals__text deals__text&#45;&#45;buy"><i class="ti ti-currency-dollar"></i>{{item.amount}}</div>-->
<!--                      </td>-->
<!--&lt;!&ndash;                      <td class="tw-w-1/5">&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="deals__text">{{systemStore.formatDate(item.createtime)}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;                      </td>&ndash;&gt;-->
<!--                      <td class="tw-w-[10%]">-->
<!--                        <div class="deals__text">-->
<!--                          <span v-if="item.status == 'normal'" class="tw-bg-purple-800 tw-rounded-md tw-px-3 tw-py-1">Success</span>-->
<!--                          <span v-else class="tw-bg-red-800 tw-rounded-md tw-px-3 tw-py-1">Fail</span>-->
<!--                        </div>-->
<!--                      </td>-->
<!--                    </tr>-->
<!--                    </tbody>-->

<!--                  </table>-->
<!--                </Vue3Marquee>-->
                <table class="deals__table min-w-0">
                  <tbody>
                    <swiper-container style="height: calc(50vh - 53px);" class="tw-text-white" direction="vertical" slidesPerView="5" :autoplay="{delay: 6000}">

                        <swiper-slide class="tw-w-full tw-table" v-for="(item, index) in systemStore.getVirtualWithdrawList" :key="index">
                          <tr>
                            <td class="tw-w-1/5">
                              <div class="deals__text">{{item.username}}</div>
                            </td>
                            <td class="tw-w-1/5">
                              <div class="deals__text deals__exchange"><img v-if="item.image" :src="item.image" alt="">{{item.coin_name}}</div>
                            </td>
                            <td class="tw-w-1/5">
                              <div class="deals__text deals__text--buy"><i class="ti ti-currency-dollar"></i>{{item.amount}}</div>
                            </td>
                            <!--                      <td class="tw-w-1/5">-->
                            <!--                        <div class="deals__text">{{systemStore.formatDate(item.createtime)}}</div>-->
                            <!--                      </td>-->
                            <td class="tw-w-[10%]">
                              <div class="deals__text">
                                <span v-if="item.status == 'normal'" class="tw-bg-purple-800 tw-rounded-md tw-px-3 tw-py-1">Success</span>
                                <span v-else class="tw-bg-red-800 tw-rounded-md tw-px-3 tw-py-1">Fail</span>
                              </div>
                            </td>
                          </tr>
                        </swiper-slide>

                    </swiper-container>
                  </tbody>
                </table>
              </div>

              <!-- design elements -->
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
              <span class="screw screw--lines-tl"></span>
            </div>
          </div>
          <!-- end deals table -->

          <!--          <div class="col-12">-->
          <!--            &lt;!&ndash; section btns &ndash;&gt;-->
          <!--            <div class="section__btns">-->
          <!--              <a href="reports.html" class="section__btn">Berichte ansehen</a>-->
          <!--            </div>-->
          <!--            &lt;!&ndash; end section btns &ndash;&gt;-->
          <!--          </div>-->
        </div>
      </div>
    </section>
    <!-- end recent deals -->

    <!-- About Our Company -->
    <section class="section">
      <div class="container">
        <div class="row row--relative">
          <div class="col-12">
            <div class="company mt-0">
              <el-row :gutter="systemStore.getIsMobile? 0: 30" class="w-full m-0">
                <el-col :span="24" :md="12">
                  <el-image class="tw-w-full tw-rounded-lg" :src="systemStore.getFrontModuleContent(4)?.image" fit="contain"></el-image>
                </el-col>
                <el-col :span="24" :md="12">
                  <h2 class="company__title xs:text-center">{{systemStore.getFrontModuleContent(4)?.title}}</h2>
                  <div class="text-[1.2rem] text-white">{{systemStore.getFrontModuleContent(4)?.sub_title}}</div>
                  <div class="feature__text text-left mt-3">
                    {{systemStore.getFrontModuleContent(4)?.description}}
                  </div>
                  <button class="tw-w-full tw-justify-self-center mt-4 section__btn section__btn--light" type="button">Get Started Now <i class="ti ti-arrow-move-right ml-2 text-[28px]"></i></button>
                </el-col>
              </el-row>

              <!-- design elements -->
              <span class="block-icon block-icon--orange">
							  <i class="ti ti-certificate-2"></i>
						  </span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>

            <!-- animation background -->
            <div class="tw-left-0 tw-top-0 tw-w-full tw-h-full section__canvas section__canvas--second4" id="canvas4"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- end About Our Company -->

    <!-- roadmap -->
    <section class="section">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="roadmap">
              <h2 class="roadmap__title">{{systemStore.getFrontModuleContent(18).title}}</h2>

              <!-- carousel -->
              <div class="roadmap__carousel splide splide--roadmap">
                <div class="splide__arrows">
                  <button class="splide__arrow splide__arrow--prev" type="button"><i class="ti ti-arrow-left"></i></button>
                  <button class="splide__arrow splide__arrow--next" type="button"><i class="ti ti-arrow-right"></i></button>
                </div>

                <div class="splide__track">
                  <ul class="splide__list">

                    <!--                    <li class="splide__slide">-->
                    <!--                      &lt;!&ndash; step &ndash;&gt;-->
                    <!--                      <div class="roadmap__block roadmap__block&#45;&#45;active">-->
                    <!--                        <h3 class="roadmap__block-title">2024 Q1</h3>-->
                    <!--                        <ul class="roadmap__block-list">-->
                    <!--                          <li>Launch the beta version of the website for a limited user group to gather feedback.</li>-->
                    <!--                          <li>Test and optimize the trading algorithms to ensure accuracy and efficiency.</li>-->
                    <!--                          <li>Implement robust security measures, including encryption and two-factor authentication.</li>-->
                    <!--                        </ul>-->
                    <!--                      </div>-->
                    <!--                      &lt;!&ndash; end step &ndash;&gt;-->
                    <!--                    </li>-->

                    <li class="splide__slide" v-for="(item, index) in systemStore.getFrontModuleContent(18)?.json_data" :key="index">
                      <!-- step -->
                      <div class="roadmap__block roadmap__block--active">
                        <h3 class="roadmap__block-title">{{item.title}}</h3>
                        <ul class="roadmap__block-list">
                          <li>{{item.desc}}</li>
                        </ul>
                      </div>
                      <!-- end step -->
                    </li>
                  </ul>
                </div>
              </div>
              <!-- end carousel -->


              <!-- design elements -->
              <span class="block-icon block-icon--blue">
							<i class="ti ti-north-star"></i>
						</span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- end roadmap -->


    <!-- Our Priority -->
    <section class="section">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-8 offset-xl-2">
            <div class="section__title">
              <h2>{{systemStore.getFrontModuleContent(8).title}}</h2>
              <p>{{systemStore.getFrontModuleContent(8).sub_title}}</p>
            </div>
          </div>
          <!-- end title -->
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <el-row :gutter="systemStore.getIsMobile? 0: 30">
              <el-col class="mt-4" :span="24" :md="8" v-for="(item, index) in systemStore.getFrontModuleContent(8)?.json_data" :key="index">
                <div class="card-bg-active p-5 tw-relative tw-h-full">
                  <div class="feature__text">{{item.desc}}</div>
                  <div class="tw-flex tw-justify-start tw-items-center tw-mt-3 tw-mb-2">
                    <el-avatar size="large" :src="item.image"></el-avatar>
                    <div class="text-white text-left tw-ml-4">
                      <div class="text-[20px]">{{item.title}}</div>
                      <div>{{item.sub_title}}</div>
                    </div>
                  </div>

                  <span class="screw screw--lines-bl"></span>
                  <span class="screw screw--lines-br"></span>
                  <span class="screw screw--lines-tr"></span>
                  <span class="screw screw--lines-tl"></span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </section>
    <!-- end Our Priority -->

    <!-- what is cloud mining -->
    <div class="section section--pb">
      <div class="container">
        <div class="row row--relative">
          <div class="col-12">
            <div class="about">
              <h2 class="about__title">{{systemStore.getFrontModuleContent(17, 1)?.title}}</h2>

              <p class="about__text">{{systemStore.getFrontModuleContent(17, 1)?.description}}</p>
              <!-- design elements -->
              <span class="block-icon block-icon--purple">
							<i class="ti ti-binary"></i>
						</span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
          </div>

          <!-- animation background -->
          <div class="section__canvas section__canvas--page section__canvas--first" id="canvas2"></div>
        </div>
      </div>
    </div>
    <!-- end what is cloud mining -->

    <!-- faq -->
    <section class="section tw-mt-20">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-8 offset-xl-2">
            <div class="section__title">
              <h2>{{systemStore.getFrontModuleContent(6)?.title}}</h2>
              <p>{{systemStore.getFrontModuleContent(6)?.sub_title}}</p>
            </div>
          </div>
          <!-- end title -->
        </div>

        <div class="row">
          <!-- tabs content -->
          <div class="col-12">
            <div class="tab-content">
              <div class="tab-pane fade show active" id="tab-1" role="tabpanel">
                <div class="row">
                  <!-- accordion -->
                  <div class="col-12">
                    <div class="accordion" id="accordion">
                      <div class="row">
                        <div class="col-12 col-lg-6" v-for="(item, index) in systemStore.getFrontModuleContent(6)?.json_data" :key="index">
                          <div class="accordion__card">
                            <button class="collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse'+index" aria-expanded="false" :aria-controls="'collapse'+index">{{item.title}}</button>

                            <div :id="'collapse'+index" class="collapse visible" data-bs-parent="#accordion">
                              <p>{{item.desc}}</p>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <!-- end accordion -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- end faq -->

    <!-- partners -->
    <section class="section">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-8 offset-xl-2">
            <div class="section__title">
              <h2>{{systemStore.getFrontModuleContent(21).title}}</h2>
              <p>{{systemStore.getFrontModuleContent(21).sub_title}}</p>
            </div>
          </div>
          <!-- end title -->
        </div>

        <div class="row">
          <div class="col-6 col-lg-3" v-for="(item, index) in systemStore.getFrontModuleContent(21)?.json_data" :key="index">
            <!-- partner -->
            <a href="#" class="partner tw-bg-white">
              <img :src="item.image" alt="">
              <p class="!tw-text-black">{{item.title}}</p>

              <!-- design elements -->
              <span class="screw screw--br"></span>
              <span class="screw screw--bl"></span>
              <span class="screw screw--tr"></span>
              <span class="screw screw--tl"></span>
            </a>
            <!-- end partner -->
          </div>

        </div>
      </div>
    </section>
    <!-- end partners -->


    <!-- Payment We Accept -->
<!--    <section class="section">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          &lt;!&ndash; title &ndash;&gt;-->
<!--          <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-8 offset-xl-2">-->
<!--            <div class="section__title">-->
<!--              <h2>{{systemStore.getFrontModuleContent(9).title}}</h2>-->
<!--              <p>{{systemStore.getFrontModuleContent(9).sub_title}}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash; end title &ndash;&gt;-->
<!--        </div>-->

<!--        <div class="row">-->
<!--          <div class="col-12">-->
<!--            <div class="roadmap mt-4 rounded-md">-->
<!--              <div class="tw-shadow-[inset_0_0_20px_0_rgba(0,0,0,0.25)] tw-rounded-lg tw-w-full">-->
<!--                &lt;!&ndash; carousel &ndash;&gt;-->
<!--                &lt;!&ndash; 插件地址 https://www.npmjs.com/package/vue3-marquee &ndash;&gt;-->
<!--                <Vue3Marquee class="tw-w-full" :pauseOnHover="true">-->
<!--                  <div class="tw-px-4" v-for="(item, index) in systemStore.getFrontModuleContent(9)?.images_list" :key="index">-->
<!--                    <el-image :src="item" class="tw-h-[100px] tw-w-[280px]" fit="fill"></el-image>-->
<!--                  </div>-->
<!--                </Vue3Marquee>-->
<!--                &lt;!&ndash; end carousel &ndash;&gt;-->
<!--              </div>-->

<!--              &lt;!&ndash; design elements &ndash;&gt;-->
<!--              <span class="block-icon block-icon&#45;&#45;blue">-->
<!--							  <i class="ti ti-north-star"></i>-->
<!--						  </span>-->
<!--              <span class="screw screw&#45;&#45;lines-bl"></span>-->
<!--              <span class="screw screw&#45;&#45;lines-br"></span>-->
<!--              <span class="screw screw&#45;&#45;lines-tr"></span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
    <!-- end Payment We Accept -->


    <!-- company -->
    <section class="section">
      <div class="container">
        <div class="row row--relative">
          <div class="col-12">
            <div class="company">
              <h2 class="company__title">{{systemStore.getFrontModuleContent(19).title}}</h2>

              <div class="row" v-if="systemStore.getFrontModuleContent(19)?.json_data">
                <div class="col-12 col-xl-7">
                  <p class="company__text">{{systemStore.getFrontModuleContent(19).description}}</p>
<!--                  <p class="company__text">{{ systemStore.getFrontModuleContent(19)?.json_data[1].title }} <b>{{ systemStore.getFrontModuleContent(19)?.json_data[1].desc }}</b></p>-->
                </div>

                <div class="col-12 col-xl-4 offset-xl-1">
                  <p class="company__subtitle">{{ systemStore.getFrontModuleContent(19)?.json_data[0].title }}</p>
                  <p class="company__text">{{ systemStore.getFrontModuleContent(19)?.json_data[0].desc }}</p>
                </div>
              </div>

              <!-- design elements -->
              <span class="block-icon block-icon--orange">
							<i class="ti ti-certificate-2"></i>
						</span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
          </div>

          <!-- animation background -->
          <div class="section__canvas section__canvas--second" id="canvas3"></div>
        </div>
      </div>
    </section>
    <!-- end company -->

<!--    &lt;!&ndash; investing &ndash;&gt;-->
<!--    <section class="section">-->
<!--      <div class="container">-->
<!--        <div class="row row&#45;&#45;relative">-->
<!--          <div class="col-12 col-lg-6">-->
<!--            &lt;!&ndash; invest &ndash;&gt;-->
<!--            <div class="invest">-->
<!--              <h2 class="invest__title">{{systemStore.getFrontModuleContent(22).title}}</h2>-->

<!--              <ul class="invest__list">-->
<!--                <li v-for="(item, index) in systemStore.getFrontModuleContent(22)?.json_data" :key="index">-->
<!--                  {{item.title}} {{item.desc}}-->
<!--                </li>-->
<!--              </ul>-->

<!--              &lt;!&ndash;              <a href="invest.html" class="invest__link">Arbitrage-Pools</a>&ndash;&gt;-->

<!--              &lt;!&ndash; design elements &ndash;&gt;-->
<!--              <span class="block-icon block-icon&#45;&#45;orange">-->
<!--							<i class="ti ti-database-dollar"></i>-->
<!--						</span>-->
<!--              <span class="screw screw&#45;&#45;lines-bl"></span>-->
<!--              <span class="screw screw&#45;&#45;lines-br"></span>-->
<!--              <span class="screw screw&#45;&#45;lines-tr"></span>-->
<!--            </div>-->
<!--            &lt;!&ndash; end invest &ndash;&gt;-->
<!--          </div>-->

<!--          <div class="col-12 col-lg-6">-->
<!--            &lt;!&ndash; invest &ndash;&gt;-->
<!--            <div class="invest">-->
<!--              <h2 class="invest__title">{{systemStore.getFrontModuleContent(22, 1)?.title}}</h2>-->

<!--              <div class="invest__rate-wrap" v-for="(item, index) in systemStore.getFrontModuleContent(22, 1)?.json_data" :key="index">-->
<!--                <div class="invest__rate">-->
<!--                  <span>{{item.title}}</span>-->
<!--                  <p class="green">{{item.desc}}</p>-->
<!--                </div>-->

<!--                <div class="invest__graph">-->
<!--                  <img :src="`img/graph/graph${index+1}.svg`" alt="">-->
<!--                </div>-->
<!--              </div>-->

<!--              &lt;!&ndash;              <a href="token.html" class="invest__link">Mehr über den Token</a>&ndash;&gt;-->

<!--              &lt;!&ndash; design elements &ndash;&gt;-->
<!--              <span class="block-icon block-icon&#45;&#45;blue">-->
<!--							<i class="ti ti-brand-coinbase"></i>-->
<!--						</span>-->
<!--              <span class="screw screw&#45;&#45;lines-bl"></span>-->
<!--              <span class="screw screw&#45;&#45;lines-br"></span>-->
<!--              <span class="screw screw&#45;&#45;lines-tr"></span>-->
<!--            </div>-->
<!--            &lt;!&ndash; end invest &ndash;&gt;-->
<!--          </div>-->

<!--          &lt;!&ndash; animation background &ndash;&gt;-->
<!--          <div class="section__canvas section__canvas&#45;&#45;first" id="canvas"></div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
<!--    &lt;!&ndash; end investing &ndash;&gt;-->


</template>

<style scoped>
video {
  border-radius: 10px;
  object-fit: cover;
}
</style>
